/*
 * @Description: 新增、编辑服务项目对话框中各面板共用的数据
 * @Author: sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2022-05-31 17:39:22
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
    mode: '',
    serviceCfgBaseInfoDO: {},
    serviceCfg: {
        timeRange: [],
    },
    modeMap: {},//服务模式数据
    svcTypeCfgDOList: {},
    sloganList: [],
    userFile: null,
    serviceFile: null,
    timeRange: [],
    serviceItemCfgList: [],
    institutionList: [],
    matterCfgBaseInfoDO: {},
    servicePkgCfgList: [],
}

const mutations = {
    changeMode(stateN, mode) {
        stateN.mode = mode;
    },

    changeServiceCfgBaseInfoDO(stateN, serviceCfgBaseInfoDO) {
        stateN.serviceCfgBaseInfoDO = serviceCfgBaseInfoDO;
    },

    changeServiceCfg(stateN, serviceCfg){
        stateN.serviceCfg = serviceCfg;
    },

    changeUserFile(stateN, userFile) {
        stateN.userFile = userFile;
    },

    changeServiceFile(stateN, serviceFile) {
        stateN.serviceFile = serviceFile;
    },

    changeSvcTypeCfgDOList(stateN, svcTypeCfgDOList) {
        stateN.serviceCfg.category = stateN.mode == 'add' 
          ? svcTypeCfgDOList[0].hsvcTypeCfgDOList[0].categoryType 
          : stateN.serviceCfg.category;
        stateN.serviceCfg.startTime = stateN.mode == 'add' 
          ? svcTypeCfgDOList[0].startTime 
          : stateN.serviceCfg.startTime;
        stateN.serviceCfg.endTime = stateN.mode == 'add' 
          ? svcTypeCfgDOList[0].endTime 
          : stateN.serviceCfg.endTime;
        stateN.serviceCfg.isWholeDay = stateN.mode == 'add' 
          ? svcTypeCfgDOList[0].isWholeDay 
          : stateN.serviceCfg.isWholeDay;
        stateN.svcTypeCfgDOList = svcTypeCfgDOList
    },

    changeModeMap(stateN, modeMap) {
        stateN.modeMap = modeMap
    },

    changeInstitutionList(stateN, institutionList) {
        stateN.institutionList = institutionList
    },

    changeSloganList(stateN, sloganList) {
        stateN.sloganList = sloganList
    },

    changeServiceItemCfgList(stateN, serviceItemCfgList) {
        stateN.serviceItemCfgList = serviceItemCfgList;
    },

    changeMatterCfgBaseInfoDO(stateN, matterCfgBaseInfoDO) {
        stateN.matterCfgBaseInfoDO = matterCfgBaseInfoDO;
    },

    changeServicePkgCfgList(stateN, servicePkgCfgList) {
        stateN.servicePkgCfgList = servicePkgCfgList;
    },
}

export default new Vuex.Store({
    state: state,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/components/hsvcmng/components/hservicedetails/HserviceDetailStore.js